import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSettings } from "../../lib/settings";

const links = [
  { to: "/", label: "Home" },
  { to: "/sermons", label: "Sermons" },
  { to: "/prayer", label: "Prayer" },
  { to: "/events", label: "Events" },
  { to: "/about", label: "About" },
  { to: "/visit", label: "Visit" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const { settings } = useSettings();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md bg-[hsl(var(--linen))]/85 border-b border-[hsl(var(--line))]"
    >
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-baseline gap-2">
          <span className="display text-2xl text-[hsl(var(--ink))]">{settings.short_name}</span>
          <span className="text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--terracotta))] hidden sm:inline">
            Church
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide under-line ${
                  isActive ? "text-[hsl(var(--terracotta))]" : "text-[hsl(var(--ink))]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/give"
            data-testid="nav-give-cta"
            className="lift inline-flex items-center px-5 py-2.5 rounded-sm bg-[hsl(var(--terracotta))] hover:bg-[hsl(var(--terracotta-deep))] text-[hsl(var(--linen))] text-sm tracking-wide"
          >
            Give
          </Link>
        </div>

        <button
          data-testid="menu-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[hsl(var(--line))] bg-[hsl(var(--linen))]">
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-[hsl(var(--terracotta))]" : "text-[hsl(var(--ink))]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/give"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-give-cta"
              className="mt-2 inline-flex items-center justify-center px-5 py-2.5 rounded-sm bg-[hsl(var(--terracotta))] text-[hsl(var(--linen))]"
            >
              Give
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
